<template>
    <div>
        <DRow>
            <DCol>
                <DTabs class="mb-3">
                    <DTabItem
                        id="cron-job-settings"
                        :route-url="$route('administrations.cron-jobs.index')"
                        :active="['administrations.cron-jobs.index'].includes($route().current())"
                        :label="__('administrations.cron_jobs.tabs.index')"
                    />
                    <DTabItem
                        id="cron-job-executions"
                        :route-url="$route('administrations.cron-jobs.executions')"
                        :active="['administrations.cron-jobs.executions'].includes($route().current())"
                        :label="__('administrations.cron_jobs.tabs.executions')"
                    />
                </DTabs>
            </DCol>
        </DRow>

        <slot />
    </div>
</template>

<script>
export default {
    name: 'CronJobLayout'
}
</script>
